import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import englishTranslationHome from "./locales/en/home.json";
import arabicTranslationHome from "./locales/ar/home.json";
import englishTranslationCommon from "./locales/en/common.json";
import arabicTranslationCommon from "./locales/ar/common.json";
import englishTranslationAccommodation from "./locales/en/accommodation.json";
import arabicTranslationAccommodation from "./locales/ar/accommodation.json";
import englishTranslationVehicle from "./locales/en/vehicle.json";
import arabicTranslationVehicle from "./locales/ar/vehicle.json";
import englishTranslationLegal from "./locales/en/legal.json";
import arabicTranslationLegal from "./locales/ar/legal.json";
import englishTranslationSeo from "./locales/en/seo.json";
import arabicTranslationSeo from "./locales/ar/seo.json";

const resources = {
  en: {
    home: englishTranslationHome,
    common: englishTranslationCommon,
    accommodation: englishTranslationAccommodation,
    vehicle: englishTranslationVehicle,
    legal: englishTranslationLegal,
    seo: englishTranslationSeo,
  },
  ar: {
    home: arabicTranslationHome,
    common: arabicTranslationCommon,
    accommodation: arabicTranslationAccommodation,
    vehicle: arabicTranslationVehicle,
    legal: arabicTranslationLegal,
    seo: arabicTranslationSeo,
  },
};

const lang = localStorage.getItem("lang") || "en";
const dir = lang === "ar" ? "rtl" : "ltr";
if (typeof document !== "undefined") {
  document.documentElement.lang = lang;
  document.documentElement.dir = dir;
  document.body.dir = dir;
}

i18n.use(initReactI18next).init({
  resources,
  lng: lang,
  fallbackLng: "en",
  keySeparator: ".",
  nsSeparator: ":",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
